import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const TextContentBlock = styled(Block)`
  ${paddingBuilder.all(0)}
  margin-top: ${themeSpace(3)};

  order: 2;

  ${tablet768`
    ${paddingBuilder.all(0)}
    width: 80%;
    align-self: center;
  `}

  ${desktop1024`
    ${paddingBuilder.all(0)}
    width: 50%;
    margin-top: 0;
  `}
`;

TextContentBlock.displayName = 'TextContentBlock';

export default TextContentBlock;
